import { BaseSceneEventsController } from "./_BaseEventsController";
export var KeyboardEventType = /* @__PURE__ */ ((KeyboardEventType2) => {
  KeyboardEventType2["keydown"] = "keydown";
  KeyboardEventType2["keypress"] = "keypress";
  KeyboardEventType2["keyup"] = "keyup";
  return KeyboardEventType2;
})(KeyboardEventType || {});
export const ACCEPTED_KEYBOARD_EVENT_TYPES = [
  "keydown" /* keydown */,
  "keypress" /* keypress */,
  "keyup" /* keyup */
];
export class KeyboardEventsController extends BaseSceneEventsController {
  constructor() {
    super(...arguments);
    this._requireCanvasEventListeners = true;
  }
  type() {
    return "keyboard";
  }
  acceptedEventTypes() {
    return new Set(ACCEPTED_KEYBOARD_EVENT_TYPES.map((n) => `${n}`));
  }
}
